import { defineMessages } from 'react-intl';

export const scope = 'app.containers.GeneratedReportsPage';

export default defineMessages({
  pageTitle: {
    id: `${scope}.pageTitle`,
    defaultMessage: 'Generated Reports',
  },
});
